import { render, staticRenderFns } from "./WebstoreApiTokenNewButton.vue?vue&type=template&id=5c323f04&scoped=true&"
import script from "./WebstoreApiTokenNewButton.vue?vue&type=script&lang=ts&"
export * from "./WebstoreApiTokenNewButton.vue?vue&type=script&lang=ts&"
import style0 from "./WebstoreApiTokenNewButton.vue?vue&type=style&index=0&id=5c323f04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c323f04",
  null
  
)

export default component.exports